module.exports = __webpack_public_path__ + "static/media/ic_pdf_upload.2e2ba653.svg";